import React from 'react';

export default function Footer() {
  return (
    <div style={{
      position: 'relative',
      zIndex: 0,
      marginTop: 40,
      paddingBottom: 24,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 6,
      userSelect: 'none',
    }}>
      {/* Simple divider */}
      <div style={{
        width: '100%',
        maxWidth: 320,
        height: 1,
        marginBottom: 14,
        background: 'rgba(0,0,0,0.08)',
        borderRadius: 999,
      }}/>

      {/* Powered by Havells */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        fontSize: 11,
        fontWeight: 600,
        color: 'rgba(100,116,139,0.7)',
        letterSpacing: 0.2,
        fontFamily: "-apple-system,BlinkMacSystemFont,'SF Pro Display','Inter',sans-serif",
      }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C12 2 5 9.5 5 14a7 7 0 0014 0C19 9.5 12 2 12 2Z"
            fill="#0ea5e9" opacity="0.7"/>
        </svg>
        <span>Powered by</span>
        <span style={{
          color: '#0ea5e9',
          fontWeight: 800,
          fontSize: 12,
          letterSpacing: -0.2,
        }}>
          Havells
        </span>
      </div>

      {/* Sub-line */}
      <div style={{
        fontSize: 10,
        color: 'rgba(100,116,139,0.4)',
        letterSpacing: 0.3,
        fontFamily: "-apple-system,BlinkMacSystemFont,'SF Pro Display','Inter',sans-serif",
      }}>
        © {new Date().getFullYear()} Havells · All rights reserved
      </div>
    </div>
  );
}
